import React from "react";
import InputGroup from 'react-bootstrap/InputGroup';
import InfoButton from "../../InfoButton";
import {IntlMessageValue} from "../../../component/const/IntlMessage";

interface UniInputGroupHelpTextProps {
    /** Tooltip text for InfoButton (required) */
    text: string;
    /** Optional icon for InfoButton */
    icon?: string;
    /** Optional DOM ID */
    id?: string;
    /** Optional class attribute */
    class?: string;
    /** The data store used for internationalization */
    Store: any;
    /** Render plain text instead of InfoButton */
    asPlainText?: boolean;
}

/**
 * Renders either an InfoButton or plain gray help text inside an InputGroup.
 *
 * @param props
 * @constructor
 */
const UniInputGroupHelpText = (props: UniInputGroupHelpTextProps) => {
    const className: string = props.class ?? 'mb-3';
    const id: string = props.id ?? '';
    const message = IntlMessageValue('de', props.text, props.Store);

    return (
        <InputGroup.Text id={id} className={className}>
            {props.asPlainText ? (
                <span className="text-muted small d-flex px-3 ">
                    <span className="material-icons pe-2">
                        {props.icon ?? process.env.REACT_APP_INFOBUTTON_ICON ?? 'info'}
                    </span>
                    {message}
                </span>
            ) : (
                <InfoButton
                    text={message}
                    icon={props.icon ?? process.env.REACT_APP_INFOBUTTON_ICON ?? 'info'}
                />
            )}
        </InputGroup.Text>
    );
};

export default UniInputGroupHelpText;
